import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { TokenService } from 'src/app/shared/service/token.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-create-menu',
  templateUrl: './create-menu.component.html',
  styleUrls: ['./create-menu.component.scss']
})
export class CreateMenuComponent implements OnInit {

  CreateMenuModel: any = {};
  loading = false;

  constructor(private router: Router, private http: HttpClient, private toastr: ToastrService,private TokenService: TokenService,) {
    const a = JSON.parse(this.TokenService.getUser().Authority);
    if (!a['MegaMenu']) {
      router.navigateByUrl('/');
    }
   }

  ngOnInit() {
  }


  CreateMegaMenu(){
    this.loading = true;
    
    const body = {  MenuName: this.CreateMenuModel.MenuName,  LanguageCode: this.CreateMenuModel.LanguageCode ,IsActive : this.CreateMenuModel.IsActive ,IsFooterMenu: false};
    this.http.post<any>(environment.url + 'Menu/CreateMegaMenu', body).subscribe(data => {
      if (data) {
        this.loading = false;
        this.toastr.success("Menü Eklendi !", '', {
          timeOut: 2000,
        });
        this.router.navigate(["/home/menus/mega-menu"]);
      }
    },
      error => {
        this.toastr.error('Menü Oluşturulamadı!', 'Hata!', {
          timeOut: 2000,
        });
        this.loading = false;
      });

  }

}
